export var preferenceUtils = function($ngRedux) {
  const factory = {};
  const constants = {
    MILE_PER_KM: 0.621371,
  };
  // keeep track of users preferences
  factory.state = {
    preferences: {
      // defaults when waiting for user to load
      userTimeFormat: 12,
      forecastTimeFormat: 12,
      units: 'imperial',
    },
  };

  // map the redux state to preferences
  const mapStateToThis = function(state) {
    const userPreferencesState = state.user.info.preferences;

    return {
      state: {
        preferences: userPreferencesState,
      },
    };
  };
  $ngRedux.connect(mapStateToThis)(factory);

  factory.kmToMile = function(km) {
    return km * constants.MILE_PER_KM;
  };

  factory.mileToKm = function(mile) {
    return mile / constants.MILE_PER_KM;
  };

  factory.distance = function(value) {
    if (factory.state.preferences.units !== 'imperial') {
      return factory.mileToKm(value);
    }
    return value;
  };


  factory.apiDistance = function(value) {
    // check if its already in api units
    const isApiUnits = factory.state.preferences.units === 'imperial';

    if (isApiUnits) {
      return value;
    }

    const convertedUnits = factory.kmToMile(value);

    return convertedUnits;
  };

  factory.interval = function(value) {
    // value is in seconds, divide by 60 to get minutes
    return value / 60;
  };

  factory.apiInterval = function(value) {
    // value is in minutes, multiply by 60 to get minutes
    return value * 60;
  };

  factory.units = function() {
    return factory.state.preferences.units;
  };

  factory.hourFormat = function() {
    return factory.state.preferences.userTimeFormat;
  };


  return factory;
};
